class DetailsDrawer extends HTMLElement {
  constructor() {
    super();
    // Add click listener to handle clicks on the drawer element itself
    this.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick(event) {
    // Close drawer when clicking on the overlay or the drawer background
    if (
      event.target.id === 'DetailsDrawer-Overlay' ||
      event.target.classList.contains('details-drawer__overlay') ||
      event.target === this
    ) {
      this.close();
    }
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    // Add global ESC listener
    this._escHandler = (evt) => {
      if (evt.key === 'Escape') {
        evt.preventDefault();
        this.close();
      }
    };
    document.addEventListener('keydown', this._escHandler);

    const detailsDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (detailsDrawerNote && !detailsDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(detailsDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('DetailsDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true },
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');

    // Remove ESC listener
    if (this._escHandler) {
      document.removeEventListener('keydown', this._escHandler);
      this._escHandler = null;
    }

    // Restore scroll
    document.body.classList.remove('overflow-hidden');

    // Restore focus
    removeTrapFocus(this.activeElement);
  }

  setSummaryAccessibility(detailsDrawerNote) {
    detailsDrawerNote.setAttribute('role', 'button');
    detailsDrawerNote.setAttribute('aria-expanded', 'false');

    if (detailsDrawerNote.nextElementSibling.getAttribute('id')) {
      detailsDrawerNote.setAttribute('aria-controls', detailsDrawerNote.nextElementSibling.id);
    }

    detailsDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    detailsDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      // Ensure overlay click handler is bound after content is rendered
      this.bindOverlayClick();
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'details-drawer',
        selector: '#DetailsDrawer',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('details-drawer', DetailsDrawer);

class DetailsDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'DetailsDrawer',
        section: 'details-drawer',
        selector: '.drawer__inner',
      },
    ];
  }
}

customElements.define('details-drawer-items', DetailsDrawerItems);

class DetailsDrawerTrigger extends HTMLElement {
  connectedCallback() {
    const targetId = this.dataset.target || this.getAttribute('aria-controls');
    if (targetId && !this.getAttribute('aria-controls')) {
      this.setAttribute('aria-controls', targetId);
    }

    this._onClick = (e) => {
      const id = this.dataset.target || this.getAttribute('aria-controls');
      if (!id) return;
      const drawer = document.getElementById(id);
      if (!drawer) return;

      if (e.target.closest('a,button')) e.preventDefault();

      if (typeof drawer.open === 'function') {
        drawer.open(this);
      } else {
        drawer.classList.add('active');
        document.body.classList.add('overflow-hidden');
      }
    };

    this._onKeyDown = (e) => {
      if (e.key === 'Enter' || e.key === ' ' || e.key === '') {
        e.preventDefault();
        this.click();
      }
    };

    this.addEventListener('click', this._onClick);
    this.addEventListener('keydown', this._onKeyDown);

    if (!this.hasAttribute('tabindex')) this.setAttribute('tabindex', '0');
    if (!this.hasAttribute('role')) this.setAttribute('role', 'button');
    this.setAttribute('aria-haspopup', 'dialog');
  }

  disconnectedCallback() {
    this.removeEventListener('click', this._onClick);
    this.removeEventListener('keydown', this._onKeyDown);
  }
}

customElements.define('details-drawer-trigger', DetailsDrawerTrigger);

document.addEventListener('DOMContentLoaded', function () {
  function initAccordion() {
    const header = document.querySelector('.accordion__header');
    const content = document.querySelector('.accordion__content');

    // Only activate accordion on tablet and smaller
    if (window.innerWidth <= 1024 && header && content) {
      header.addEventListener('click', function () {
        content.classList.toggle('active');
      });
    }
  }

  initAccordion();

  // Optional: re-init on resize if needed
  window.addEventListener('resize', function () {
    if (window.innerWidth <= 1024) {
      initAccordion();
    }
  });
});
